import { AVATAR_ACCEPTED_TYPES, AVATAR_MAX_BYTES } from '../constants/profileConfig';

/** @returns {string} a message if the file cannot be used as a profile picture, otherwise '' */
export const validateAvatarFile = (file) => {
    if (!file) return 'Please choose an image.';
    if (!AVATAR_ACCEPTED_TYPES.includes(file.type)) {
        return 'Please choose a JPG, PNG or WEBP image.';
    }
    if (file.size > AVATAR_MAX_BYTES) {
        return `The image is too large. The maximum size is ${Math.round(AVATAR_MAX_BYTES / (1024 * 1024))} MB.`;
    }
    return '';
};

/** Reads a failed removal of the picture. @returns {string} */
export const describeAvatarRemoveError = (error) => {
    if (!error?.response) {
        return 'Cannot reach the server. Please check your connection and try again.';
    }

    const { status, data } = error.response;
    const serverMessage = (typeof data?.detail === 'string' && data.detail.trim()) || '';

    if (status === 403) return serverMessage || 'You can only change your own profile photo.';
    if (status === 404) return 'This profile could not be found.';
    return serverMessage || 'The photo could not be removed. Please try again.';
};

/**
 * Reads a failed upload.
 *   400: not a png, jpg or webp image, or larger than 2 MB
 *   403: only the user themselves or an admin may change the picture
 *   422: validation error
 * @returns {string}
 */
export const describeAvatarUploadError = (error) => {
    if (!error?.response) {
        return 'Cannot reach the server. Please check your connection and try again.';
    }

    const { status, data } = error.response;
    const serverMessage = (typeof data?.detail === 'string' && data.detail.trim()) || '';

    if (status === 400) return serverMessage || 'Please choose a JPG, PNG or WEBP image of 2 MB or less.';
    if (status === 403) return serverMessage || 'You can only change your own profile photo.';
    if (status === 413) return 'The image is too large. The maximum size is 2 MB.';
    if (status === 422) return 'This image could not be used. Please choose another one.';
    return serverMessage || 'The photo could not be uploaded. Please try again.';
};
